import React, { useEffect } from 'react'
import isActiveUser from 'helpers/is-active-user'
import SessionManagerService from 'smart-components/session-manager/Service'
import UserResponsesManagerService from './Service'
import { useServiceState, useNotification } from 'helpers'

const Provider: React.FC = ({ children }) => {
  const sessionState = useServiceState(SessionManagerService, false)
  const { emitError } = useNotification()

  useEffect(() => {
    async function loadUserResponses() {
      const error = await UserResponsesManagerService.loadUserResponses()
      if (error) {
        emitError(error)
      }
    }

    if (isActiveUser(sessionState.currentUser)) {
      loadUserResponses()
    }
  }, [sessionState, emitError])

  return <React.Fragment>{children}</React.Fragment>
}

export default Provider
